// @flow weak

export { appConfig } from './appConfig';



// WEBPACK FOOTER //
// ./src/app/config/index.js